<template>
    <div class="conditionally-approve-wizard deny-wizard">
        <div class="denial__step denial-information__container" v-if="wizardStep === 0 && stepOneFields.length > 0">
            <p class="fields--required">All fields required</p>

            <div class="denial-pair__container denial-date-by">
                <div>
                    <label class="deny-field__label">
                        Denial Date
                        <k-datepicker disabled :default-value="new Date()"></k-datepicker>
                    </label>
                </div>
                <div>
                    <label class="deny-field__label">
                        Denied By
                        <k-input disabled v-model="stepOneFields.find(field => field.id === 'DENIAL.X70').value"></k-input>
                    </label>
                </div>
            </div>
            <div class="denial-pair__container">
                <div>
                    <label class="deny-field__label">
                        Description of Account, Transaction, or Request Credit
                        <k-textarea v-model="stepOneFields.find(field => field.id === 'DENIAL.X71').value" :rows="5"></k-textarea>
                    </label>
                </div>
                <div>
                    <label class="deny-field__label">
                        Description of Action Taken
                        <k-textarea v-model="stepOneFields.find(field => field.id === 'DENIAL.X74').value" :rows="5"></k-textarea>
                    </label>
                </div>
            </div>
            <div class="denial-pair__container">
                <div>
                    <label class="deny-field__label">
                        Borrower: Copy Address From
                        <k-dropdown :data-items="denialX81DropdownFields" v-model="stepOneFields.find(field => field.id === 'DENIAL.X81').value"></k-dropdown>
                    </label>
                </div>
            </div>
        </div>

        <div class="denial__step statement-of-denial__container" v-if="wizardStep === 1 && stepTwoFields.length > 0">
            <h4 class="step-title">Principal Reason(s) for Credit Denial, Termination or Other Action Taken Concerning Credit:</h4>
            <p class="fields--required">A minimum of one reason required</p>
            <div class="jump-to__container">
                <k-button v-for="btn in jumpToButtons" :key="btn" class="jump-to__btn" @click="jumpTo(btn)">{{ btn }}</k-button>
            </div>
            <div class="sections__container">
                <div v-bind:class="['checkboxes__container', { 'selected': jumpToSection === 'Disclosure' }]" id="DisclosureCheckboxes">
                    <p class="checkbox-section--title">Disclosure of use of information obtained from an outside source</p>
                    <p class="checkbox-section--subtitle">In compliance with Fair Credit Act, Section 615, your application was declined either wholly or partly because of:</p>
                    <label v-bind:class="['checkbox__label']">
                        <k-checkbox disabled :checked="stepTwoFields.find(field => field.id === 'DENIAL.X12').value === 'Y'" @change="setCheckboxValue($event, 'DENIAL.X12', 'stepTwoFields')"></k-checkbox>
                        {{ stepTwoFields.find(field => field.id === 'DENIAL.X12').label }}
                    </label>
                </div>

                <div v-bind:class="['checkboxes__container', { 'selected': jumpToSection === 'Credit' }]" id="CreditCheckboxes">
                    <p class="checkbox-section--title">A. Credit</p>
                    <label v-for="field in stepTwoFields.filter(field => field.section === 'Credit')" :key="field.id" v-bind:class="['checkbox__label', { 'nested': field.nested }]">
                        <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'stepTwoFields')"></k-checkbox>
                        {{ field.label }}
                    </label>
                </div>

                <div v-bind:class="['checkboxes__container', { 'selected': jumpToSection === 'Employment' }]" id="EmploymentCheckboxes">
                    <p class="checkbox-section--title">B. Employment Status</p>
                    <label v-for="field in stepTwoFields.filter(field => field.section === 'Employment Status')" :key="field.id" v-bind:class="['checkbox__label', { 'nested': field.nested }]">
                        <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'stepTwoFields')"></k-checkbox>
                        {{ field.label }}
                    </label>
                </div>

                <div v-bind:class="['checkboxes__container', { 'selected': jumpToSection === 'Income' }]" id="IncomeCheckboxes">
                    <p class="checkbox-section--title">C. Income</p>
                    <label v-for="field in stepTwoFields.filter(field => field.section === 'Income')" :key="field.id" v-bind:class="['checkbox__label', { 'nested': field.nested }]">
                        <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'stepTwoFields')"></k-checkbox>
                        {{ field.label }}
                    </label>
                </div>

                <div v-bind:class="['checkboxes__container', { 'selected': jumpToSection === 'Residency' }]" id="ResidencyCheckboxes">
                    <p class="checkbox-section--title">D. Residency</p>
                    <label v-for="field in stepTwoFields.filter(field => field.section === 'Residency')" :key="field.id" v-bind:class="['checkbox__label', { 'nested': field.nested }]">
                        <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'stepTwoFields')"></k-checkbox>
                        {{ field.label }}
                    </label>
                </div>

                <div v-bind:class="['checkboxes__container', { 'selected': jumpToSection === 'Other' }]" id="OtherCheckboxes">
                    <p class="checkbox-section--title">E. Other</p>
                    <label v-for="field in stepTwoFields.filter(field => field.section === 'Other' && field.type === 'checkbox')" :key="field.id" v-bind:class="['checkbox__label', { 'nested': field.nested }]">
                        <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'stepTwoFields')" v-if="field.display !== 'row'"></k-checkbox>
                        {{ field.label }}
                    </label>
                    <div class="input-checkbox-row" >
                        <div v-bind:class="['input-checkbox']">
                            <k-checkbox :checked="stepTwoFields.find(field => field.id === 'DENIAL.X65').value === 'Y'" @change="setCheckboxValue($event, 'DENIAL.X65', 'stepTwoFields')"></k-checkbox>
                            <k-input v-model="stepTwoFields.find(field => field.id === 'DENIAL.X66').value"></k-input>
                        </div>
                    </div>
                    <div class="input-checkbox-row" >
                        <div v-bind:class="['input-checkbox']">
                            <k-checkbox :checked="stepTwoFields.find(field => field.id === 'DENIAL.X67').value === 'Y'" @change="setCheckboxValue($event, 'DENIAL.X67', 'stepTwoFields')"></k-checkbox>
                            <k-input v-model="stepTwoFields.find(field => field.id === 'DENIAL.X68').value"></k-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="denial__step fact-act-disclosure__conatiner" v-if="wizardStep === 2 && creditReasons && stepThreeFields.length > 0">
            <h4 class="step-title">Fact Act Disclosure</h4>
            <div class="checkboxes__container" v-for="bureau in stepThreeCreditBureaus" :key="bureau.title">
                <p class="checkbox-section--title">{{ bureau.title }}</p>
                <div class="checkbox-row">
                    <div class="checkbox-column">
                        <label class="checkbox__label">
                            <k-checkbox disabled :checked="stepThreeFields.find(field => field.id === bureau.fieldsList[0]).value === 'Y'" @change="setCheckboxValue($event, bureau.fieldsList[0], 'stepThreeFields')"></k-checkbox>
                            {{ stepThreeBorrowerLabels[0] }}
                        </label>
                        <label class="checkbox__label">
                            <k-checkbox disabled :checked="stepThreeFields.find(field => field.id === bureau.fieldsList[1]).value === 'Y'" @change="setCheckboxValue($event, bureau.fieldsList[1], 'stepThreeFields')"></k-checkbox>
                            {{ stepThreeBorrowerLabels[1] }}
                        </label>
                    </div>
                    <div v-if="coBorrower" class="checkbox-column">
                        <label class="checkbox__label">
                            <k-checkbox disabled :checked="stepThreeFields.find(field => field.id === bureau.fieldsList[2]).value === 'Y'" @change="setCheckboxValue($event, bureau.fieldsList[2], 'stepThreeFields')"></k-checkbox>
                            {{ stepThreeCoborrowerLabels[0] }}
                        </label>
                        <label class="checkbox__label">
                            <k-checkbox disabled :checked="stepThreeFields.find(field => field.id === bureau.fieldsList[3]).value === 'Y'" @change="setCheckboxValue($event, bureau.fieldsList[3], 'stepThreeFields')"></k-checkbox>
                            {{ stepThreeCoborrowerLabels[1] }}
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <loan-notes-component v-if="(wizardStep === 3 && creditReasons) || (wizardStep === 2 && !creditReasons)" 
            :loan-id="loanId" 
            :wizard-view="true"
            :default-note="'Deny'"
            v-on:wizardnoteadded="addWizardNote"></loan-notes-component>

        <div class="denial__step review-save__container" v-if="((wizardStep === 4 && creditReasons) || (wizardStep === 3 && !creditReasons)) && stepOneFields.length > 0 && stepTwoFields.length > 0 && stepThreeFields.length > 0">
            <h3 class="step--label">Denial Information</h3>
            <div class="denial-pair__container">
                <div>
                    <label class="deny-field__label">
                        Description of Account, Transaction, or Request Credit
                        <k-textarea disabled v-model="stepOneFields.find(field => field.id === 'DENIAL.X71').value" :rows="5"></k-textarea>
                    </label>
                </div>
                <div>
                    <label class="deny-field__label">
                        Description of Action Taken
                        <k-textarea disabled v-model="stepOneFields.find(field => field.id === 'DENIAL.X74').value" :rows="5"></k-textarea>
                    </label>
                </div>
            </div>
            <div class="denial-pair__container">
                <div>
                    <label class="deny-field__label">
                        Borrower: Copy Address From
                        <k-dropdown disabled :data-items="denialX81DropdownFields" v-model="stepOneFields.find(field => field.id === 'DENIAL.X81').value"></k-dropdown>
                    </label>
                </div>
            </div>

            <h3 class="step--label">Statement of Denial</h3>
            <div class="notes__container">
                <div v-for="field in stepTwoFields.filter(field => field.value === 'Y')" :key="field.id" class="note">
                    <p v-if="field.type !== 'inputcheckbox'">{{ field.label }}</p>
                    <p v-if="field.type === 'inputcheckbox'">{{ stepTwoFields.find(f => f.id === field.input).value }}</p>
                </div>
            </div>

            <h3 class="step--label">New Notes Added</h3>
            <div class="notes__container">
                <div v-for="note in addedNotes" :key="note" class="note">
                    <blockquote v-html="note"></blockquote>
                </div>
                <div v-if="addedNotes.length === 0">
                    <p class="no-notes">No disposition notes available</p>
                </div>
            </div>
        </div>

        <div class="conditions__loader-container" v-if="isLoading">
            <loader :size="'large'" :type="'infinite-spinner'"></loader>
        </div>


        <transition name="dialogfade">
            <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
            <p class="error-dialog__msg">{{ errorMsg }}</p>
            </k-dialog>
        </transition> 
    </div>
</template>

<script>
    import auth from '../authConfig.js';
    import apiService from '../api/api.service.js';

    import cloneDeep from 'lodash.clonedeep';

    import { Dialog, DialogActionsBar, Window } from '@progress/kendo-vue-dialogs';
    import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
    import { Loader } from "@progress/kendo-vue-indicators";
    import { Button } from '@progress/kendo-vue-buttons';
    import { Input, TextArea, Checkbox } from '@progress/kendo-vue-inputs';
    import { Fade, Reveal, Slide } from "@progress/kendo-vue-animation";
    import { DatePicker } from '@progress/kendo-vue-dateinputs';

    import { filterBy } from '@progress/kendo-data-query';

    import loanNotesComponent from './loanNotesComponent.vue';

    export default {
        props: ['finishClicked', 'loanId', 'wizardStep'],
        emits: ['allstepsvalidated', 'setcurrentstepcleared', 'loandenied', 'creditreasons', 'requestfailed'],
        data() {
            return {
                addedNotes: [],
                coBorrower: false,
                creditReasons: false,
                denialFieldsList: ['CX.UWI.DENIEDCHECK', 'DENIAL.X69', 'DENIAL.X70', 'DENIAL.X71', 'DENIAL.X74', 'DENIAL.X81', 'DENIAL.X30', 'DENIAL.X31', 'DENIAL.X32', 'DENIAL.X33', 'DENIAL.X34', 'DENIAL.X101', 'DENIAL.X102', 'DENIAL.X103',
                    'DENIAL.X35', 'DENIAL.X36', 'DENIAL.X37', 'DENIAL.X39', 'DENIAL.X40', 'DENIAL.X77', 'DENIAL.X78', 'DENIAL.X79', 'DENIAL.X42', 'DENIAL.X43', 'DENIAL.X44', 'DENIAL.X45', 'DENIAL.X46', 'DENIAL.X104', 'DENIAL.X47', 'DENIAL.X48', 'DENIAL.X49',
                    'DENIAL.X57', 'DENIAL.X58', 'DENIAL.X59', 'DENIAL.X60', 'DENIAL.X61', 'DENIAL.X62', 'DENIAL.X80', 'DENIAL.X63', 'DENIAL.X65', 'DENIAL.X66', 'DENIAL.X67', 'DENIAL.X68', 'DENIAL.X12', 'DISCLOSURE.X943', 'DISCLOSURE.X625', 'DISCLOSURE.X944',
                    'DISCLOSURE.X626', 'DISCLOSURE.X945', 'DISCLOSURE.X627', 'DISCLOSURE.X946', 'DISCLOSURE.X628', 'DISCLOSURE.X947', 'DISCLOSURE.X629', 'DISCLOSURE.X948', 'DISCLOSURE.X630'],
                denialFields: [],
                denialX81DropdownFields: ['Present Address', 'Mailing Address', 'Subject Address'],
                isLoading: false,
                isTPO: false,
                jumpToButtons: ['Disclosure', 'Credit', 'Employment', 'Income', 'Residency', 'Other'],
                showErrorDialog: false,
                errorMsg: '',
                errorTitle: '',
                jumpToSection: '',
                milestones: [
                    { milestoneName: 'Completion', id: '', doneIndicator: null },
                    { milestoneName: 'Post Closing', id: '', doneIndicator: null },
                    { milestoneName: 'Note Delivery', id: '', doneIndicator: null },
                    { milestoneName: 'Purchased', id: '', doneIndicator: null },
                    { milestoneName: 'Funding', id: '', doneIndicator: null },
                    { milestoneName: 'Correspondent Funding', id: '', doneIndicator: null },
                    { milestoneName: 'Docs Signing', id: '', doneIndicator: null },
                    { milestoneName: 'Doc Preparation', id: '', doneIndicator: null },
                    { milestoneName: 'QC Review', id: '', doneIndicator: null },
                    { milestoneName: 'Approval', id: '', doneIndicator: null },
                    { milestoneName: 'Resubmittal', id: '', doneIndicator: null },
                    { milestoneName: "Cond'l Approval", id: '', doneIndicator: null },
                    { milestoneName: 'Submittal', id: '', doneIndicator: null },
                    { milestoneName: 'Processing', id: '', doneIndicator: null },
                    { milestoneName: 'Package Received', id: '', doneIndicator: null },
                    { milestoneName: 'Send to Jr Processor', id: '', doneIndicator: null },
                    { milestoneName: 'File Management', id: '', doneIndicator: null },
                    { milestoneName: 'Qualification', id: '', doneIndicator: null },
                    { milestoneName: 'Ready for Disclosures', id: '', doneIndicator: null },
                    { milestoneName: 'Initial Disclosures Sent', id: '', doneIndicator: null }
                ],
                stepOneFields:[],
                stepOneFieldsList: ['DENIAL.X69', 'DENIAL.X70', 'DENIAL.X71', 'DENIAL.X74', 'DENIAL.X81'],
                stepThreeCreditBureaus: [
                    { title: 'Experian', fieldsList: ['DISCLOSURE.X943', 'DISCLOSURE.X625', 'DISCLOSURE.X944', 'DISCLOSURE.X626']},
                    { title: 'Trans Union', fieldsList: ['DISCLOSURE.X945', 'DISCLOSURE.X627', 'DISCLOSURE.X946', 'DISCLOSURE.X628']},
                    { title: 'Equifax', fieldsList: ['DISCLOSURE.X947', 'DISCLOSURE.X629', 'DISCLOSURE.X948', 'DISCLOSURE.X630']}
                ],
                stepThreeBorrowerFields: ['DISCLOSURE.X943', 'DISCLOSURE.X625', 'DISCLOSURE.X945', 'DISCLOSURE.X627', 'DISCLOSURE.X947', 'DISCLOSURE.X629'],
                stepThreeCoborrowerFields: ['DISCLOSURE.X944', 'DISCLOSURE.X626', 'DISCLOSURE.X946', 'DISCLOSURE.X628', 'DISCLOSURE.X948', 'DISCLOSURE.X630'],
                stepThreeBorrowerLabels: ['Borrower: Material Terms of Credit Set by Credit Score', 'Borrower: Credit Score for Disclosure Notice'],
                stepThreeCoborrowerLabels: ['Co-Borrower: Material Terms of Credit Set by Credit Score', 'Co-Borrower: Credit Score for Disclosure Notice'],
                stepThreeFields: [],
                stepThreeFieldsList: ['DISCLOSURE.X943', 'DISCLOSURE.X625', 'DISCLOSURE.X944', 'DISCLOSURE.X626', 'DISCLOSURE.X945', 'DISCLOSURE.X627', 'DISCLOSURE.X946', 'DISCLOSURE.X628',
                    'DISCLOSURE.X947', 'DISCLOSURE.X629', 'DISCLOSURE.X948', 'DISCLOSURE.X630'],
                stepTwoFields:[
                    { section: 'Credit', nested: false, label: 'No Credit File', value: null, id: 'DENIAL.X30', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Insufficient Number of Credit References Provided', value: null, id: 'DENIAL.X31', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Limited Credit Experience', value: null, id: 'DENIAL.X32', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Unable to Verify Credit References', value: null, id: 'DENIAL.X33', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Garnishment, Attachment, Foreclosure, Repossession or Collection Action or Judgment', value: null, id: 'DENIAL.X34', type: 'checkbox' },
                    { section: 'Credit', nested: true, label: 'Garnishment or Attachment', value: null, id: 'DENIAL.X101', type: 'checkbox' },
                    { section: 'Credit', nested: true, label: 'Foreclosure or Repossession', value: null, id: 'DENIAL.X102', type: 'checkbox' },
                    { section: 'Credit', nested: true, label: 'Collection Action or Judgment', value: null, id: 'DENIAL.X103', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Excessive Obligations', value: null, id: 'DENIAL.X35', type: 'checkbox' },
                    { section: 'Credit', nested: true, label: 'Insufficient Income for Total Obligations', value: null, id: 'DENIAL.X36', type: 'checkbox' },
                    { section: 'Credit', nested: true, label: 'Unacceptable Payment Record on Previous Mortgage', value: null, id: 'DENIAL.X37', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Delinquent Past or Present Credit Obligations with Others', value: null, id: 'DENIAL.X39', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Bankruptcy', value: null, id: 'DENIAL.X40', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Unacceptable Type of Credit References Provided', value: null, id: 'DENIAL.X77', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Poor Credit Performance With Us', value: null, id: 'DENIAL.X78', type: 'checkbox' },
                    { section: 'Credit', nested: false, label: 'Number of Recent Inquiries on Credit Bureau Report', value: null, id: 'DENIAL.X79', type: 'checkbox' },
                    { section: 'Employment Status', nested: false, label: 'Unable to Verify Employment', value: null, id: 'DENIAL.X42', type: 'checkbox' },
                    { section: 'Employment Status', nested: false, label: 'Length of Employment', value: null, id: 'DENIAL.X43', type: 'checkbox' },
                    { section: 'Employment Status', nested: false, label: 'Temporary or Irregular Employment', value: null, id: 'DENIAL.X44', type: 'checkbox' },
                    { section: 'Income', nested: false, label: 'Income Insufficient for Amount of Credit Requested', value: null, id: 'DENIAL.X45', type: 'checkbox' },
                    { section: 'Income', nested: false, label: 'Unable to Verify Income', value: null, id: 'DENIAL.X46', type: 'checkbox' },
                    { section: 'Income', nested: false, label: 'Excessive Obligations in Relation to Income', value: null, id: 'DENIAL.X104', type: 'checkbox' },
                    { section: 'Residency', nested: false, label: 'Temporary Residence', value: null, id: 'DENIAL.X47', type: 'checkbox' },
                    { section: 'Residency', nested: true, label: 'Length of Residence', value: null, id: 'DENIAL.X48', type: 'checkbox' },
                    { section: 'Residency', nested: false, label: 'Unable to Verify Residence', value: null, id: 'DENIAL.X49', type: 'checkbox' },
                    { section: 'Other', nested: false, label: 'Credit Application Incomplete', value: null, id: 'DENIAL.X57', type: 'checkbox' },
                    { section: 'Other', nested: false, label: 'Inadequate Collateral', value: null, id: 'DENIAL.X58', type: 'checkbox' },
                    { section: 'Other', nested: true, label: 'Unacceptable Property', value: null, id: 'DENIAL.X59', type: 'checkbox' },
                    { section: 'Other', nested: true, label: 'Insufficient Data - Property', value: null, id: 'DENIAL.X60', type: 'checkbox' },
                    { section: 'Other', nested: true, label: 'Unacceptable Appraisal', value: null, id: 'DENIAL.X61', type: 'checkbox' },
                    { section: 'Other', nested: true, label: 'Unacceptable Leasehold Estate', value: null, id: 'DENIAL.X62', type: 'checkbox' },
                    { section: 'Other', nested: true, label: 'Value or Type of Collateral is Not Sufficient', value: null, id: 'DENIAL.X80', type: 'checkbox' },
                    { section: 'Other', nested: false, label: 'We do not grant credit to any applicant on…', value: null, id: 'DENIAL.X63', type: 'checkbox' },
                    { section: 'Other', nested: false, label: '', value: null, id: 'DENIAL.X65', type: 'inputcheckbox', input: 'DENIAL.X66'},
                    { section: 'Other', nested: false, label: '', value: null, id: 'DENIAL.X66', type: 'input' },
                    { section: 'Other', nested: false, label: '', value: null, id: 'DENIAL.X67', type: 'inputcheckbox', input: 'DENIAL.X68' },
                    { section: 'Other', nested: false, label: '', value: null, id: 'DENIAL.X68', type: 'input' },
                    { section: 'Disclosure', nested: false, label: 'Information obtained in a report from a consumer reporting agency', value: null, id: 'DENIAL.X12', type: 'checkbox' }
                ],
                stepTwoFieldsList: ['DENIAL.X30', 'DENIAL.X31', 'DENIAL.X32', 'DENIAL.X33', 'DENIAL.X34', 'DENIAL.X101', 'DENIAL.X102', 'DENIAL.X103', 'DENIAL.X35', 'DENIAL.X36', 'DENIAL.X37', 'DENIAL.X39', 'DENIAL.X40', 'DENIAL.X77', 
                    'DENIAL.X78', 'DENIAL.X79', 'DENIAL.X42', 'DENIAL.X43', 'DENIAL.X44', 'DENIAL.X45', 'DENIAL.X46', 'DENIAL.X104', 'DENIAL.X47', 'DENIAL.X48', 'DENIAL.X49',
                    'DENIAL.X57', 'DENIAL.X58', 'DENIAL.X59', 'DENIAL.X60', 'DENIAL.X61', 'DENIAL.X62', 'DENIAL.X80', 'DENIAL.X63', 'DENIAL.X65', 'DENIAL.X66', 'DENIAL.X67', 'DENIAL.X68', 'DENIAL.X12'],
                tpoMilestones: [
                    { milestoneName: 'Completion', id: '', doneIndicator: null },
                    { milestoneName: 'Post Closing', id: '', doneIndicator: null },
                    { milestoneName: 'Note Delivery', id: '', doneIndicator: null },
                    { milestoneName: 'Purchased', id: '', doneIndicator: null },
                    { milestoneName: 'Funding', id: '', doneIndicator: null },
                    { milestoneName: 'Correspondent Funding', id: '', doneIndicator: null },
                    { milestoneName: 'Docs Signing', id: '', doneIndicator: null },
                    { milestoneName: 'Doc Preparation', id: '', doneIndicator: null },
                    { milestoneName: 'QC Review', id: '', doneIndicator: null },
                    { milestoneName: 'Approval', id: '', doneIndicator: null },
                    { milestoneName: 'Resubmittal', id: '', doneIndicator: null },
                    { milestoneName: "Cond'l Approval", id: '', doneIndicator: null },
                    { milestoneName: 'Submittal', id: '', doneIndicator: null },
                    { milestoneName: 'Processing', id: '', doneIndicator: null }
                ],
                userName: ''
            }
        },
        watch: {
            finishClicked(val) {
                if (val) {
                    this.dispositionLoan();
                }
            },
            stepOneFields: {
                handler(val) {
                    if (val.some(field => !field.value)) {
                        this.$emit('allstepsvalidated', false);
                        return this.$emit('setcurrentstepcleared', false, 0);
                    } 

                    this.$emit('setcurrentstepcleared', true, 0);
                }, 
                deep: true
            },
            stepTwoFields: {
                handler(val) {
                    let checkedValues = val.filter(field => field.value === 'Y');

                    if (checkedValues.length === 0) {
                        this.$emit('allstepsvalidated', false);
                        return this.$emit('setcurrentstepcleared', false, 1);
                    }

                    if (checkedValues.some(field => field.section === 'Credit')) {
                        val.find(field => field.section === 'Disclosure').value = 'Y';
                        this.creditReasons = true;
                        this.$emit('creditreasons', true);

                        if (this.coBorrower) {
                            this.stepThreeFields.forEach(field => field.value = 'Y');
                        } else {
                            this.stepThreeFields.forEach(field => {
                                if (this.stepThreeBorrowerFields.some(f => f === field.id)) {
                                    field.value = 'Y';
                                }
                            });
                        }

                        this.$emit('allstepsvalidated', true);
                        return this.$emit('setcurrentstepcleared', true, 1);
                    } else {
                        this.creditReasons = false;
                        this.$emit('creditreasons', false);
                        val.find(field => field.section === 'Disclosure').value = 'N';

                        if (this.coBorrower) {
                            this.stepThreeFields.forEach(field => field.value = 'N');
                        } else {
                            this.stepThreeFields.forEach(field => {
                                if (this.stepThreeBorrowerFields.some(f => f === field.id)) {
                                    field.value = 'N';
                                }
                            });
                        }
                    }

                    if (checkedValues.length >= 1) {
                        return this.$emit('setcurrentstepcleared', true, 1);
                    } 

                    this.$emit('allstepsvalidated', false);
                    return this.$emit('setcurrentstepcleared', false, 1);
                }, 
                deep: true
            },
            wizardStep(val) {
                if (val === 1) {
                    this.jumpToSection = '';
                }
            }
        },
        async mounted() {
            this.isTPO = sessionStorage.getItem('loanchannel') === 'Banked - Wholesale';
            this.isLoading = true;
            
            await this.getMilestones();
            await this.getDenyFields();

            this.isLoading = false;
        },
        methods: {
            addWizardNote(noteHtml) {
                this.addedNotes.push(noteHtml);
            },
            async dispositionLoan() {
                let fields = [this.stepOneFields, this.stepTwoFields, this.stepThreeFields].flat().filter(field => field.value).map(field => {
                    let value;

                    if (field.type !== 'checkbox' && field.type !== 'inputcheckbox') {
                        value = field.value;
                    } else {
                        value = field.value === 'Y' ? 'true' : 'false';
                    }

                    return {
                        id: field.id,
                        value: value
                    }
                });

                let unfinishMilestones;

                if (this.isTPO) {
                    unfinishMilestones = this.tpoMilestones.filter(milestone => milestone.doneIndicator).map(milestone => milestone.id);
                } else {
                    unfinishMilestones = this.milestones.filter(milestone => milestone.doneIndicator).map(milestone => milestone.id);
                }
                
                let request = {
                    loanId: this.loanId,
                    fields: fields,
                    unfinishMilestones: unfinishMilestones
                }

                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.DenyLoan(request, tokenResponse.accessToken)
                    .then(res => {
                        sessionStorage.setItem('isdenied', "true");

                        this.isLoading = false;
                        return this.$emit('loandenied', 'File denied successfully');
                    }).catch(error => {
                        this.errorTitle = 'Failed to Disposition Loan';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                        this.$emit('requestfailed');
                    });
            },
            async getDenyFields() {
                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.GetLoanFieldList(this.loanId, this.denialFieldsList, tokenResponse.accessToken)
                    .then(res => {
                        this.userName = res.data.message;

                        this.denialFields = res.data.data.map(field => {
                            return {
                                id: field.fieldId,
                                value: field.value
                            }
                        });

                        this.denialFields.find(field => field.id === 'DENIAL.X69').value = new Date().toLocaleDateString();
                        this.denialFields.find(field => field.id === 'DENIAL.X70').value = this.userName;
                        this.denialFields.find(field => field.id === 'DENIAL.X81').value = this.denialFields.find(field => field.id === 'DENIAL.X81').value ? this.denialFields.find(field => field.id === 'DENIAL.X81').value : 'Present Address';

                        this.stepOneFields = this.denialFields.filter(field => this.stepOneFieldsList.some(fieldName => field.id === fieldName));
                        this.stepTwoFields.forEach(field => {
                            field.value = this.denialFields.find(denialField => denialField.id === field.id)?.value;
                        });

                        this.stepThreeFields = this.denialFields.filter(field => this.stepThreeFieldsList.some(fieldName => field.id === fieldName));
                        this.stepThreeFields.forEach(field => field.type = 'checkbox');

                        this.coBorrower = +sessionStorage.getItem('borrowercount') > 1;
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Loan Fields';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getMilestones(update = false) {
                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                return apiService.GetMilestones(this.loanId, tokenResponse.accessToken)
                    .then(res => {
                        if (res.data.data) {
                            if (this.isTPO) {
                                this.tpoMilestones.forEach(milestone => {
                                    let ms = res.data.data.find(m => m.milestoneName === milestone.milestoneName);

                                    if (ms) {
                                        milestone.id = ms.id;
                                        milestone.doneIndicator = ms.doneIndicator;
                                    }
                                });
                            } else {
                                this.milestones.forEach(milestone => {
                                    let ms = res.data.data.find(m => m.milestoneName === milestone.milestoneName);

                                    if (ms) {
                                        milestone.id = ms.id;
                                        milestone.doneIndicator = ms.doneIndicator;
                                    }
                                });
                            }
                        }
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Milestones';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            jumpTo(btn) {
                let selectedSection = document.getElementById(`${btn}Checkboxes`);

                if (selectedSection) {
                    this.jumpToSection = btn;
                    selectedSection.scrollIntoView(true);
                }
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.toggleErrorDialog();
            },
            setCheckboxValue(evt, fieldId, stepFields) {
                this[stepFields].find(field => field.id === fieldId).value = evt.value ? 'Y' : 'N';
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if (!this.showErrorDialog) {
                    this.errorMsg = '';
                    this.errorTitle = '';
                }
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'loan-notes-component': loanNotesComponent,
            'loader': Loader,
            'k-button': Button,
            'k-dropdown': DropDownList,
            'k-input': Input,
            'k-fade': Fade,
            'k-datepicker': DatePicker,
            'k-textarea': TextArea,
            'k-checkbox': Checkbox
        }
    }
</script>

<style>
    @import '/src/assets/css/conditionallyApproveWizard.css';
    @import '/src/assets/css/denyWizard.css';
</style>